import React from "react";
import "./Skill.css";
import Intro from "../Intro/Intro";
import {skillList} from "../../assets/skillsData"
import SkillComponent  from "./SkillComponent/SkillComponent";
export default function Skill(props) {
    return <div className="skill-container">
        <div className="inner-container">
        <Intro header={"Skills"} content={"I am passionate about new technologies, Here are the few technolgies that I have worked on in my projects."}/>
        <div className="skills">
         {skillList.map(skillItem=> <SkillComponent source={skillItem.skillUrl} skillName={skillItem.skillName}/>)}
        </div>

        </div>

    </div>
}